import React from 'react';
export function Footer() {
  return <footer className="bg-brown-deep text-cream py-12 px-4 md:px-8" data-id="element-43">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-between items-center gap-8" data-id="element-44">
        <div className="text-center md:text-left" data-id="element-45">
          <h3 className="text-2xl font-serif font-bold mb-2" data-id="element-46">
            Kit Vientre Plano 21D
          </h3>
          <p className="text-sm text-cream/60" data-id="element-47">
            Tu transformación empieza hoy.
          </p>
        </div>

        <div className="flex gap-6 text-sm text-cream/80" data-id="element-48">
          <a href="#" className="hover:text-white transition-colors" data-id="element-49">
            Términos y Condiciones
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-50">
            Política de Privacidad
          </a>
        </div>

        <div className="text-sm text-cream/60" data-id="element-51">Hecho con ❤️ en Argentina</div>
      </div>
      <div className="max-w-6xl mx-auto mt-8 pt-8 border-t border-white/10 text-center text-xs text-cream/40" data-id="element-52">
        © {new Date().getFullYear()} Kit Vientre Plano. Todos los derechos
        reservados.
      </div>
    </footer>;
}